/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetResolutionStatus
 */
export interface AssetResolutionStatus {
    /**
     * 
     * @type {Date}
     * @memberof AssetResolutionStatus
     */
    resolvedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof AssetResolutionStatus
     */
    resolvedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof AssetResolutionStatus
     */
    resolutionMethod?: AssetResolutionStatusResolutionMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof AssetResolutionStatus
     */
    notes?: string;
}


/**
 * @export
 */
export const AssetResolutionStatusResolutionMethodEnum = {
    Patched: 'PATCHED',
    WorkaroundApplied: 'WORKAROUND_APPLIED',
    AssetDecommissioned: 'ASSET_DECOMMISSIONED',
    FalsePositive: 'FALSE_POSITIVE',
    ConfigurationChange: 'CONFIGURATION_CHANGE'
} as const;
export type AssetResolutionStatusResolutionMethodEnum = typeof AssetResolutionStatusResolutionMethodEnum[keyof typeof AssetResolutionStatusResolutionMethodEnum];


/**
 * Check if a given object implements the AssetResolutionStatus interface.
 */
export function instanceOfAssetResolutionStatus(value: object): value is AssetResolutionStatus {
    return true;
}

export function AssetResolutionStatusFromJSON(json: any): AssetResolutionStatus {
    return AssetResolutionStatusFromJSONTyped(json, false);
}

export function AssetResolutionStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetResolutionStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'resolvedAt': json['resolvedAt'] == null ? undefined : (new Date(json['resolvedAt'])),
        'resolvedBy': json['resolvedBy'] == null ? undefined : json['resolvedBy'],
        'resolutionMethod': json['resolutionMethod'] == null ? undefined : json['resolutionMethod'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function AssetResolutionStatusToJSON(json: any): AssetResolutionStatus {
    return AssetResolutionStatusToJSONTyped(json, false);
}

export function AssetResolutionStatusToJSONTyped(value?: AssetResolutionStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'resolvedAt': value['resolvedAt'] == null ? undefined : ((value['resolvedAt']).toISOString()),
        'resolvedBy': value['resolvedBy'],
        'resolutionMethod': value['resolutionMethod'],
        'notes': value['notes'],
    };
}

